import React, { useState } from 'react';
import { Box } from '@mui/material';
import { TextInput } from '@rentspree/component-2023.components.atoms.text-input';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';

export const stepTitle = "Where's your place located?";
export const stepDescription = '';

const InputAddress: React.FC = () => {
  const [address, setAddress] = useState('');

  return (
    <Box
      sx={{
        maxWidth: { xs: '100%', sm: 700, md: 800, lg: 900 },
        mx: 'auto',
        px: { xs: 1, sm: 2, md: 3 },
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
      }}
    >
      {/* Address Input - centered and consistent width */}
      <Box sx={{ width: '100%', maxWidth: 600 }}>
        <TextInput
          placeholder='Enter your address'
          fullWidth
          value={address}
          onChange={e => setAddress(e.target.value)}
        />
      </Box>

      {/* Map Placeholder - same width as input */}
      <Box
        sx={{
          width: '100%',
          maxWidth: 600, // Same width as input for consistency
          height: 400,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          position: 'relative',
        }}
      >
        {/* Map Icon */}
        <Box
          sx={{
            width: 48,
            height: 48,
            backgroundColor: '#bdbdbd',
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path
              d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
              fill='#757575'
            />
          </svg>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant='body1'
            sx={{ color: '#757575', fontWeight: 500 }}
          >
            Interactive map will appear here
          </Typography>
          <Typography variant='body2' sx={{ color: '#9e9e9e' }}>
            Enter an address to see the location
          </Typography>
        </Box>

        {/* Map Copyright */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 8,
            right: 8,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <Typography
            variant='caption'
            sx={{ color: '#757575', fontSize: '0.75rem' }}
          >
            Map data ©2024
          </Typography>
        </Box>

        {/* Fullscreen Icon */}
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            width: 32,
            height: 32,
            backgroundColor: 'white',
            borderRadius: 1,
            border: '1px solid #e0e0e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          <svg width='16' height='16' viewBox='0 0 24 24' fill='none'>
            <path
              d='M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z'
              fill='#757575'
            />
          </svg>
        </Box>
      </Box>
    </Box>
  );
};

export default InputAddress;
